import ExternalAudienceTargetingType from '../../campaigns/modules/common-campaign-form/config/ExternalAudienceTargetingType';

const getOnlyCategories = selectedValues => {
    return selectedValues.filter(item => {
        const num = Number(item);
        return !isNaN(num);
    });
};

const getOnlyDomains = selectedValues => {
    return selectedValues.filter(item => {
        const num = Number(item);
        return isNaN(num);
    });
};

const createMRTTargetingValue = (targetingType, valueMap) => ({
    type: targetingType,
    values: Object.entries(valueMap).map(([valueType, values]) => ({
        type: valueType,
        values,
    })),
});

export const buildMRTGroup = (domainList, targetingType) => {
    const mailDomains = getOnlyDomains(domainList);
    const categories = getOnlyCategories(domainList);
    const valuesMap = {};

    if (mailDomains.length) {
        valuesMap[ExternalAudienceTargetingType.MRT_DOMAINS] = mailDomains;
    }

    if (categories.length) {
        valuesMap[ExternalAudienceTargetingType.MRT_CATEGORIES] = categories;
    }

    if (Object.keys(valuesMap).length) {
        return createMRTTargetingValue(targetingType, valuesMap);
    }

    return null;
};
